<template>
  <validation-provider v-slot="{ errors, validate }" :name="name" :rules="rules" :vid='vid'>
    <b-field :label="name"
             class="personal-info__field"
             custom-class="personal-info__field-label"
             :type="{ 'is-danger': errors.length }"
             :value="value"
             :message="errors + [ '&nbsp;' ]">

      <template v-if="tooltip">
        <template slot="label">
          {{ name }}<b-tooltip :label="tooltip"
                     type="is-info"
                     :size="size ? size : windowWidth <= 760 ? 'is-small' : 'is-large'"
                     :position="windowWidth <= 760 && position === 'is-right' ? 'is-top' : position"
                     :class="tooltipClasses"
                     :delay="200"
                     animated
                     multilined>
            <b-icon :pack="iconPack" size="is-small" icon="question-circle"></b-icon>
          </b-tooltip>
        </template>
      </template>
      <template v-if="editable">
        <template v-if="type === 'file'">
          <b-input type="file" @change.native="validate"
                   autocomplete="new-password"
                   @input.native="$emit('input', $event.target.value)"></b-input>
        </template>
        <template v-else-if="type === 'list'">
          <b-select placeholder="Select a value"
                    :value="value"
                    @change.native="$emit('input', $event.target.value)">
            <option disabled value="">Select the option</option>
            <option v-for="option in listItems"
                    :value="option"
                    :key="option">{{ option }}</option>
          </b-select>
        </template>
        <template v-else>
          <b-input :value="value"
                   :type="type"
                   autocomplete="new-password"
                   @input.native="$emit('input', $event.target.value)"
                   @blur="blur"
                   @paste.native="$emit('paste', $event)"
                   @focusin.native="$emit('focusin', $event)"
                   :maxlength="maxlength" :password-reveal="passwordReveal"
                   :placeholder="placeholder"
                   :disabled="disabled"></b-input>
        </template>
      </template>
      <template v-else>
        <slot name="raw">{{ value }}</slot>
      </template>
    </b-field>
  </validation-provider>
</template>

<script>
export default {
  name: 'Field',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    message: {
      type: Array,
      default: () => [],
    },
    listItems: {
      type: Array,
      default: () => [],
    },
    position: {
      type: String,
      default: 'is-top',
    },
    tooltip: String,
    vid: String,
    maxlength: {},
    type: {
      type: String,
      default: 'text',
    },
    name: String,
    passwordReveal: Boolean,
    rules: {},
    value: {},
    blur: {},
    editable: {
      type: Boolean,
      default: false,
    },
    iconPack: {
      type: String,
      default: 'far',
    },
    tooltipClasses: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: null,
    },
  },

  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  methods: {
    inputMask(event) {
      return (numberMask = false) => {
        if (!numberMask) return true;
        const { keyCode } = event;
        if (
          (keyCode >= 37 && keyCode <= 40)
          || (keyCode >= 48 && keyCode <= 57)
          || [8, 36, 35].indexOf(keyCode) !== -1
          || (keyCode >= 96 && keyCode <= 105)
        ) return true;
        event.preventDefault();
        return false;
      };
    },
  },
};
</script>

<style scoped>
</style>
